import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Filter.css';

interface IFilterProps
  extends Pick<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'className'>,
    React.PropsWithChildren {}

export const Filter: React.FC<IFilterProps> = props => {
  const className = classNames(styles['container'], props.className);

  return <div className={className}>{props.children}</div>;
};
